// extracted by mini-css-extract-plugin
export var orderSummary = "_st-0";
export var showMoreLessButton = "_st-1";